import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getDepreciationById,
  modifyDepreciation,
  modifyCustomField, //Groups
  addDepreciation,
  updateDepreciation,
  addYear,
  removeYear,
} from 'depreciations/actions';

import { getEditing } from 'depreciations/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { getCustomFieldsEmployees } from 'custom_fields_employees/actions'; //Groups
import { getGroups } from 'groups/actions'; //Groups

import { valueFromEvent, createRoute } from 'lib/util';

class DepreciationsFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { did } = this.props.match.params;
    this.props.reset();
    did && this.props.getById(did, this.props.company.id, this.props.subcompany.id);
    //Groups
    this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    const filters = { fulltext: 'depreciaciones', columnSearch: ['module'] }; // Filtros para traer solo los grupos de empleados
    this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
    //Groups
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.depreciation.id
          ? this.props.update(
              this.props.depreciation.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.depreciation
            )
          : this.props.add(
              this.props.company.id,
              this.props.subcompany.id,
              this.props.depreciation
            );

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'depreciations')
            );
          })
          .catch((err) => {
            this.finishSaving();
            this.props.error(err.message);
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  handleValueChange = (e) => {
    let payload = valueFromEvent(e);
    payload = Object.keys(payload).reduce((re, k) => {
      if (
        k.indexOf('.percentages[') > -1 ||
        k.indexOf('maximumAmount') > -1 ||
        k.indexOf('maximumPercent') > -1 ||
        k.indexOf('lastYearMonths') > -1
      ) {
        re[k] = parseFloat(payload[k]);
        re[k] = re[k] !== re[k] ? '' : re[k];
      } else {
        re[k] = payload[k];
      }

      return re;
    }, {});

    this.props.modify(payload);
  };

  //Groups
  handleGroupChange = (e) => {
    const { value } = e.target;
    let _group = [{ _id: value }];
    if (value == 'null' || value == '' || value == null || value == undefined) _group = [];
    this.props.modify({ _group });
  };

  handleCustomFieldChange = (e) => this.props.modifyCustomField(valueFromEvent(e)); // Especial para custom fields
  //Groups

  handleValidation = (isValid) => this.setState({ isValid });

  handleAddYear = () => this.props.addYear();

  handleRemoveYear = (index) => this.props.removeYear(index);

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleAddYear: this.handleAddYear,
      handleRemoveYear: this.handleRemoveYear,
      handleSubmit: this.handleSubmit,
      handleCustomFieldChange: this.handleCustomFieldChange, //Groups
      handleGroupChange: this.handleGroupChange, //Groups
      handleValueChange: this.handleValueChange,
      handleValidation: this.handleValidation,
    });
}

const mapStateToProps = (state) => ({
  depreciation: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addDepreciation,
  error: addGrowlError,
  getById: getDepreciationById,
  modify: modifyDepreciation,
  getCustomFields: getCustomFieldsEmployees, //Groups
  getGroups: getGroups, //Groups
  modifyCustomField: modifyCustomField, //Groups
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateDepreciation,
  addYear,
  removeYear,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DepreciationsFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/containers/DepreciationFormHandlers.js